import axios from 'axios';
import BaseApi from './base-api';

class ChangeOrdersApi extends BaseApi {
  getChangeOrders(workOrderId) {
    return axios
      .get(`${this.baseUrl}/work_orders/${workOrderId}/change_orders`)
      .then((response) => {
        return {
          ok: true,
          changeOrders: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  createChangeOrder(
    workOrderId,
    startDate,
    completionDate,
    addedValues,
    qualifications
  ) {
    const apiPayload = {
      change_order: {
        start_date: startDate,
        completion_date: completionDate,
        change_order_proposal_tasks_attributes: addedValues,
        change_order_qualifications_attributes: qualifications,
      },
    };

    return axios
      .post(
        `${this.baseUrl}/work_orders/${workOrderId}/change_orders`,
        apiPayload
      )
      .then((response) => {
        return {
          ok: true,
          changeOrder: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  approveChangeOrder(changeOrderId) {
    return axios
      .put(`${this.baseUrl}/change_orders/${changeOrderId}/approve`)
      .then((response) => {
        return {
          ok: true,
          changeOrder: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  withdrawChangeOrder(changeOrderId) {
    return axios
      .put(`${this.baseUrl}/change_orders/${changeOrderId}/withdraw`)
      .then((response) => {
        return {
          ok: true,
          changeOrder: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  getAsPdf(changeOrderId) {
    return axios
      .get(`${this.baseUrl}/change_orders/${changeOrderId}/print`, {
        responseType: 'blob',
      })
      .then((response) => {
        return {
          ok: true,
          pdf: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  sendEmail(changeOrderId, emails, subject, message) {
    const data = {
      change_order: {
        send_to: emails,
        subject: subject,
        message: message,
      },
    };
    return axios
      .put(`${this.baseUrl}/change_orders/${changeOrderId}/email`, data)
      .then((response) => {
        return {
          ok: true,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }
}

export const changeOrdersApi = new ChangeOrdersApi();



// WEBPACK FOOTER //
// ./src/services/api/change-orders-api.js